class Link {
  /**
   * @param {HTMLAnchorElement} link
   */
  constructor(link) {
    this.link = link;
    this.connect();
  }

  connect = () => {
    let url;

    try {
      url = new URL(this.link.href);
    } catch (e) {
      return;
    }

    if (window.location.href === url.href) {
      this.link.setAttribute("aria-current", "page");
    } else if (window.location.origin !== url.origin) {
      this.link.setAttribute("target", "_blank");
      this.link.setAttribute("rel", "noopener noreferrer");
      this.link.setAttribute("data-external", "true");
    }
  };
}

export default Link;
